import ENVIRONMENTS from '@/constants/environments';

export default function determineEnvFromLocation(): string {
  const host = window.location.host;
  if (host.includes('localhost')) {
    return ENVIRONMENTS.LOCAL;
  } else if (host.includes('staging')) {
    return ENVIRONMENTS.STAGING;
  } else {
    return ENVIRONMENTS.PRODUCTION;
  }
}
